import React, { useEffect } from 'react';
import Header from './Header';

const DatenschutzPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#E8F5E0] to-white">
      <Header />
      
      <div className="pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            
            <div className="border-b-2 border-[#1A3A2E] pb-6 mb-8">
              <h1 className="text-4xl font-bold text-[#1A3A2E] mb-2">
                Datenschutzerklärung
              </h1>
              <p className="text-gray-600">NOVATUS Energie GmbH</p>
            </div>

            <div className="space-y-8 text-gray-800">
              {/* 1. Allgemeine Hinweise */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">1. Allgemeine Hinweise</h2>
                <p className="leading-relaxed">
                  Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen. Die NOVATUS Energie GmbH verarbeitet Ihre personenbezogenen Daten ausschließlich im Einklang mit den gesetzlichen Datenschutzvorschriften, insbesondere der Datenschutz-Grundverordnung (DSGVO) und dem Bundesdatenschutzgesetz (BDSG).
                </p>
              </section>

              {/* 2. Verantwortlicher */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">2. Verantwortlicher</h2>
                <div className="bg-[#E8F5E0] p-6 rounded-lg">
                  <p className="font-bold">NOVATUS Energie GmbH</p>
                  <p>vertr. durch den Geschäftsführer Dipl.-Verw. Wiss. Christof Schirm</p>
                  <p>Maximiliankorso 60, 13465 Berlin</p>
                  <p className="mt-2">
                    <strong>Telefon:</strong> +49 (0)30 398205700<br/>
                    <strong>E-Mail:</strong> info@novatus-se.com
                  </p>
                </div>
              </section>

              {/* 3. Erhebung und Verarbeitung */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">3. Erhebung und Verarbeitung personenbezogener Daten</h2>
                <p className="leading-relaxed mb-4">
                  Wir verarbeiten personenbezogene Daten nur, soweit dies zur Begründung, Durchführung oder Beendigung von Vertragsverhältnissen erforderlich ist oder Sie ausdrücklich eingewilligt haben.
                </p>
                <p className="leading-relaxed mb-2">Verarbeitete Daten können insbesondere sein:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Name, Adresse</li>
                  <li>Kontaktdaten (Telefon, E-Mail)</li>
                  <li>Vertrags- und Zahlungsdaten</li>
                  <li>Technische Daten (z. B. IP-Adresse bei Website-Nutzung)</li>
                </ul>
              </section>

              {/* 4. Zwecke */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">4. Zwecke der Datenverarbeitung</h2>
                <p className="leading-relaxed mb-2">Die Verarbeitung erfolgt zu folgenden Zwecken:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Vertragsabwicklung</li>
                  <li>Kundenbetreuung und Kommunikation</li>
                  <li>Erfüllung gesetzlicher Pflichten</li>
                  <li>Marketing und Information (nur mit Einwilligung)</li>
                </ul>
              </section>

              {/* 5. Rechtsgrundlagen */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">5. Rechtsgrundlagen</h2>
                <p className="leading-relaxed mb-2">Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 DSGVO:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong>a)</strong> Einwilligung</li>
                  <li><strong>b)</strong> Vertragserfüllung</li>
                  <li><strong>c)</strong> rechtliche Verpflichtung</li>
                  <li><strong>f)</strong> berechtigtes Interesse</li>
                </ul>
              </section>

              {/* 6. Weitergabe */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">6. Weitergabe von Daten</h2>
                <p className="leading-relaxed">
                  Eine Weitergabe an Dritte erfolgt nur, wenn dies gesetzlich erlaubt ist oder zur Vertragserfüllung notwendig ist (z. B. Netzbetreiber, Förderstellen, Handwerksbetriebe).
                </p>
              </section>

              {/* 7. Speicherdauer */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">7. Speicherdauer</h2>
                <p className="leading-relaxed">
                  Personenbezogene Daten werden nur so lange gespeichert, wie dies für die genannten Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen.
                </p>
              </section>

              {/* 8. Ihre Rechte */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">8. Ihre Rechte</h2>
                <p className="leading-relaxed mb-2">Sie haben das Recht auf:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Auskunft (Art. 15 DSGVO)</li>
                  <li>Berichtigung (Art. 16 DSGVO)</li>
                  <li>Löschung (Art. 17 DSGVO)</li>
                  <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                  <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
                  <li>Widerspruch (Art. 21 DSGVO)</li>
                </ul>
              </section>

              {/* 9. Widerruf */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">9. Widerruf von Einwilligungen</h2>
                <p className="leading-relaxed">
                  Erteilte Einwilligungen können jederzeit mit Wirkung für die Zukunft widerrufen werden.
                </p>
              </section>

              {/* 10. Beschwerderecht */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">10. Beschwerderecht</h2>
                <p className="leading-relaxed">
                  Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren.
                </p>
              </section>

              {/* 11. Datensicherheit */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">11. Datensicherheit</h2>
                <p className="leading-relaxed">
                  Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten gegen Verlust, Manipulation oder unbefugten Zugriff zu schützen.
                </p>
              </section>

              {/* 12. Änderungen */}
              <section>
                <h2 className="text-2xl font-bold text-[#1A3A2E] mb-4">12. Änderungen dieser Datenschutzerklärung</h2>
                <p className="leading-relaxed">
                  Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf anzupassen.
                </p>
              </section>

              {/* Unternehmensdaten */}
              <div className="mt-12 pt-8 border-t-2 border-[#1A3A2E]/20">
                <div className="bg-[#E8F5E0] p-6 rounded-lg">
                  <p className="font-bold text-[#1A3A2E] mb-2">NOVATUS Energie GmbH</p>
                  <p>Maximiliankorso 60, 13465 Berlin</p>
                  <p>Geschäftsführer: Christof Schirm</p>
                  <p>Amtsgericht Charlottenburg, HRB 222 580</p>
                  <p>USt.-ID-Nr.: DE 296 655 515</p>
                  <p className="mt-3">
                    <strong>Telefon:</strong> +49 (0)30 398205700<br/>
                    <strong>E-Mail:</strong> info@novatus-se.com
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-[#1A3A2E] text-white py-8">
        <div className="container mx-auto px-4 text-center">
          <p className="text-sm">
            © {new Date().getFullYear()} NOVATUS Energie GmbH • Alle Rechte vorbehalten
          </p>
        </div>
      </div>
    </div>
  );
};

export default DatenschutzPage;
